/**
 * Dashboard for users.role === fusionAffiliate.
 * The only application is CareMap Ads, the carousel / zip-slot desk.
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Settings from "components/dashboard/Settings";
import ZipSlotAdsGate from "components/common/ZipSlotAdsGate";
import ZipSlotBiddingPage from "pages/dashboard/zipSlotAds/ZipSlotBiddingPage";
import AdBalancePage from "pages/dashboard/zipSlotAds/AdBalancePage";
import AdPerformancePage from "pages/dashboard/zipSlotAds/AdPerformancePage";
import DashboardLayout from "components/dashboard/DashboardLayout";
import HomePage from "pages/dashboard/HomePage";
import { useAuth } from "hooks/useAuth";

const FusionAffiliateRoutes = () => {
  const { user, subscription } = useAuth();

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/advertising/slots"
          element={
            <ZipSlotAdsGate>
              <ZipSlotBiddingPage />
            </ZipSlotAdsGate>
          }
        />
        <Route
          path="/advertising/balance"
          element={
            <ZipSlotAdsGate>
              <AdBalancePage />
            </ZipSlotAdsGate>
          }
        />
        <Route
          path="/advertising/performance"
          element={
            <ZipSlotAdsGate>
              <AdPerformancePage />
            </ZipSlotAdsGate>
          }
        />
        <Route
          path="/settings"
          element={<Settings uid={user?.uid} subscription={subscription} />}
        />
        <Route
          path="*"
          element={<Navigate to="/dashboard/advertising/slots" replace />}
        />
      </Routes>
    </DashboardLayout>
  );
};

export default FusionAffiliateRoutes;
